import { centerable, uploadable } from '../decorators';
import { ALIGN_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const inlineImageSpec = centerable(uploadable({
  inline: true,
  draggable: true,
  attrs: {
    type: {
      default: 'inlineImage'
    },
    src: {},
    linkUrl: {
      default: ''
    },
    width: {
      default: ''
    },
    displayWidth: {
      default: ''
    },
    height: {
      default: ''
    },
    text: {
      default: ''
    }
  },
  group: 'inline',
  parseDOM: [{
    tag: '.intercom-inline-image',
    priority: 60,
    getAttrs(dom) {
      let img = dom;
      return {
        src: img.getAttribute('src'),
        text: img.getAttribute('alt'),
        width: dom.getAttribute('data-width') || dom.style.width.replace('px', '')
      };
    }
  }, {
    tag: 'img[src]',
    getAttrs(dom) {
      return {
        src: dom.getAttribute('src'),
        linkUrl: dom.getAttribute('data-link-url'),
        width: dom.getAttribute('data-width') || dom.style.width.replace('px', ''),
        height: dom.getAttribute('data-height'),
        text: dom.getAttribute('alt')
      };
    }
  }],
  toDOM(node) {
    let {
      src,
      width,
      displayWidth,
      height,
      text
    } = node.attrs;
    displayWidth = displayWidth || width;
    return ['img', {
      src,
      alt: text,
      class: `${ALIGN_CLASSES[node.attrs.alignment]} intercom-inline-image`,
      style: `width: ${displayWidth}px;`,
      'data-link-url': node.attrs.linkUrl,
      'data-height': height,
      'data-width': width
    }];
  }
}));